<template>
  <div class="p-1">
    <div-table
      :config="configList"
      :data="refunds"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :sous_idWharhouse="sous_idWharhouse"
      :sous_warehouses="sous_warehouses"
      :limit="limit"
      @reset="reset"
      @refresh="refresh"
      @filtrer="filtrer"
      @search="search"
      :ProcessingInfo="ProcessingInfo"
      :loading="loading"
      :paginate="paginate"
      :statusShipp="statusOrder"
      @paginatation="paginatation"
    ></div-table>
  </div>
</template>

<script>
import button from "../../components/~/button.vue";
import config from "./config";
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
     sous_idWharhouse: { type: String},
     sous_warehouses: { type: Array},
   },
  data() {
    return {
      configList: config.list,
      loading: false,
      formData: {
        customer: {},
      },
      refunds: [],
      sellers: [],
      tabId:[],
      show_modal: false,
      limit: 10,
      filters:{},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      statusOrder: ['pending', 'accepted', 'effectue','processed','rejected'],
      ProcessingInfo:{count:0,total:0}
    };
  },
  computed: {
    warhouseSelected(){
          return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['warehouses'])});
      },
  }, 
  watch: { 
      'warhouseSelected': async function(oldVal, newVal) {
          //  await this.getwharhouseId();
          //  await this.reset();
          //  await this.getSellers();
      },
      'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.reset();
            await this.getSellers();
      },
      'sous_idWharhouse': async function(oldVal, newVal) {
          this.sous_idWharhouse=oldVal;  
          await this.reset();
      }
},
  async mounted() {
    if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
    else {
      let filtersobjectToQueryString={limit:this.limit,warehouse:this.idWharhouse._id};
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filtersobjectToQueryString['ObjetDetails.products.warehouseParent']=this.sous_idWharhouse;
      this.$f.objectToQueryString(filtersobjectToQueryString)
    }

    if(this.filters.name) await this.search(this.filters.name);
    else await this.getOrders(this.filters);

    if(this.currentUser && this.currentUser.type && this.currentUser.type === "Administrateur") this.statusOrder=['pending', 'accepted', 'effectue'];
    await this.getSellers();
    this.setDataSelect("seller", this.sellers, null);
    this.setDataSelect("status", this.statusOrder, null);
    if (this.currentUser && this.currentUser.type && this.currentUser.type == "Seller") {
            let pos = this.configList.columns.map(function (e) {
                        return e.name;
                        }).indexOf('Seller');
            if(pos!=-1)  this.configList.columns.splice(pos, 1);           
        }
  },
  methods: {
    async getwharhouseId(){
       await this.$store.dispatch('wharhouse/getwharhouseId',{country: this.warhouseSelected,}).then((res) => {this.idWharhouse=res;})
    }, 
     sumQteProduct(data){
      let sum=0;
      for (let i in data) {
        sum=sum+data[i].quantity;
      }
      return sum;
    },
     sumProduct(data){
      let product="";
      for (let i in data) {
        product+=data[i].product.name
        if(data.length-1 != i) product+=" ,"; 
      }
      return product;
    },

     setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getSellers() {
      const filter = {
         type: "Seller",
         warehouses:this.idWharhouse._id,
         limit:10,
      };
       if (this.currentUser.type != "Seller") {
        const res = await this.$server.search("users", filter);
        if (res.content.results) this.sellers = res.content.results;
        else this.sellers = [];
       }
    },
    async reset(data) {
      let lmitt=this.limit;
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      if(this.filters['limit']) lmitt=this.filters['limit'];
      this.filters['page']=1;
      let filtersobjectToQueryString={limit:lmitt,warehouse:this.idWharhouse._id};
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filtersobjectToQueryString['ObjetDetails.products.warehouseParent']=this.sous_idWharhouse;
      this.$f.objectToQueryString(filtersobjectToQueryString)
      await this.getOrders(filtersobjectToQueryString);
    },
    async filtrer(data) {
       if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
       delete  this.filters.page;
       delete  this.filters.name;

       console.log('filter search________',data)
       this.paginate.currentpage=1;
       this.filters['warehouse']=this.idWharhouse._id;
       if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') this.filters['ObjetDetails.products.warehouseParent']=this.sous_idWharhouse;else delete this.filters['ObjetDetails.products.warehouseParent'];
       if(!this.filters['limit']) this.filters['limit']=this.limit;
       if(data.date){this.filters.date=data.date;delete this.filters.from; delete this.filters.to;}else delete this.filters.date;
       if(data.updatedAt){this.filters.updatedAt=data.updatedAt;}else delete this.filters.updatedAt;
       if(data.from && data.to){delete this.filters.date;this.filters.from=data.from;this.filters.to=data.to;}else {delete this.filters.from; delete this.filters.to;}
       if(data.seller)  {this.filters.seller=data.seller._id;}else delete this.filters.seller;
       if(data.status)  this.filters.status=data.status;else delete this.filters.status;
       this.$f.objectToQueryString(this.filters)
      await this.getOrders(this.filters);
    },
    /**********************************User and Status******************************************************/
    async getUser() {
      const res = await this.$me;
      this.currentUser = res.content;
      console.log(res.content);
    },
    async getStatusByName(name) {
        const result = await this.$server.get("status",{  name: name  });
        return result.content;
    },
    async refresh() {
        if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
        this.$f.objectToQueryString(this.filters)
        if(this.filters.name) await this.search(this.filters.name);
        else await this.getOrders(this.filters);
       if(this.filters['page'] && this.filters['page']>1 && this.refunds.length==0){
          this.filters['page']= --this.filters['page'];
           this.$f.objectToQueryString(this.filters)
          await this.getOrders(this.filters);
       }
    },
    async getOrders(filters) {
      this.loading = true;
      filters['warehouse']=this.idWharhouse._id;
      if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') filters['ObjetDetails.products.warehouseParent']=this.sous_idWharhouse;
      console.log('filter autorize__________',filters)
      const res = await this.$server.search("refunds", filters);
      this.loading = false;
       this.ProcessingInfo.count=0;this.ProcessingInfo.total=0;
      if (res.content.results) {
        this.refunds = res.content.results;
         for (const element of  this.refunds) {
              if(element.isProcessed && element.status==="effectue") {
                console.log('element---------',element)
                  this.ProcessingInfo.total+=element.ObjetDetails.totalPrice;
                  this.ProcessingInfo.count++;
              }
          }
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.refunds = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
    },
    async search(data) {
       this.paginate= {total: 0,currentpage: 1,lastpage: 1,per_page: 0,};
       let limitt=this.limit
       if(this.filters['limit']) limitt=this.filters['limit'];
      const search = {
        name:data.trim(),
        limit:parseInt(limitt)
      }
     search["warehouse"]=this.idWharhouse._id;
     if(this.sous_idWharhouse && this.sous_warehouses.length>0 && this.sous_idWharhouse!='all') search['ObjetDetails.products.warehouseParent']=this.sous_idWharhouse;
     this.$f.objectToQueryString(search)
     const  res = await this.$server.find("refunds", search);
       if (res.content.results) {
        this.refunds = res.content.results; 
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.refunds = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}
      }
        
    },
    async remove(id) {
      this.$confirm("You want to delete this order?").then(async (res) => {
        if (res) {
          const resp = await this.$server.delete("refunds", { id: id });
          await this.refresh();
          alert("order Deleted", "success");
        }
      });
    },
    /********************************************************************************************/
    async paginatation(direction) {
      var page = 0;
      if (direction == "next") {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if(this.$f.QueryStringToobject()) this.filters=this.$f.QueryStringToobject();
      this.filters['page']=page;
      this.$f.objectToQueryString(this.filters)

      this.getOrders(this.filters);
    },
  },
};
</script>

<style>
/* animation for vue transition tag */

</style>
